<template>
	<!-- <nav class="nav">
            <div class="hstack w-100">
                <div class="text-left ml-2">
                    <router-link class="navbar-brand" to="/" @click="handleNavClick(links[0])">
                        <img :src="require('@/assets/pawinhand_logo_v2.png')" class="img-logo" style="width : 50%"/>
                    </router-link>
                </div>
                <div class="ms-auto" id="open-navbar1" style="margin-top:1.3rem">
                    <ul class="list">
                        <li v-for="menu in links"><router-link class="nav-link" :class="menu.isActive ? 'active' : ''" :to='menu.to' @click="handleNavClick(menu)">{{menu.title}}</router-link></li>
                        <li style="margin-left: 4rem;"><router-link class="nav-link" to='/setting' @click="deactivateMenu()"><i class="bi bi-gear" style="color:#333; font-size: 1.1rem; "></i></router-link></li>
                        <li style="">
                            <router-link class="nav-link" to=''>
                                <button type="button" class="btn position-relative" id="alarmButton" data-bs-toggle="dropdown" aria-expanded="false" style="padding:0 0.6rem 0 0 !important">
                                    <i class="bi bi-bell" style="color:#333; font-size: 1.1rem;"></i>
                                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" v-if="alarmCount > 0">
                                        {{alarmCount}}
                                        <span class="visually-hidden">unread messages</span>
                                    </span>
                                </button>
                                <ul class="dropdown-menu" aria-labelledby="alarmButton" v-if="alarmCount > 0">
                                    <li ><a class="dropdown-item" href="#">알람 1</a></li>
                                </ul>
                                <ul class="dropdown-menu" aria-labelledby="alarmButton" v-else>
                                    <li class="dropdown-item">읽지않은 알림이 없습니다.</li>
                                </ul>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav> -->
    <div class="w-100" style="background-color: #ffffff; border-bottom: 1px solid #ececec;">
        <header class="container">
            

            <nav class="main-navbar">
                <div class="navbar__logo align-self-center" style="text-align: left;">
                    <router-link class="navbar-brand" to="/" @click="handleNavClick(links[0])">
                        <img :src="require('@/assets/pawinhand_logo_v2.png')" class="img-logo"/>
                    </router-link>
                </div>
                
                <div class="navbar__open" :class="more_clicked ? 'active' : ''">

                    <ul class ="navbar__menu align-self-center">
                        <li v-for="menu in links" >
                            <router-link v-if="menu.title != '봉사관리' || (menu.title == '봉사관리' & $root.isAdmin)"
                                         v-show="menu.title != '소식관리' || ($root.shelter.popup_active == 'ON' || $root.shelter.shelter_news == 'ON')"
                                         :class="isMenuActive(menu) ? 'active' : ''" :to='menu.to' @click="handleNavClick()">{{menu.title}}</router-link>
                        </li>
                    </ul>

                    <ul class="navbar__icons">
                        <li>
                            <router-link class="navbar-brand" to='/setting' @click="deactivateMenu(); this.more_clicked = false;" style="margin-right: 0;">
                                <button type="button" class="btn position-relative">
                                    <i class="bi bi-gear" style="color:#333; font-size: 1.1rem; "></i>
                                </button> 
                            </router-link>
                        </li>
                        <li style="">
                            <button type="button" class="btn position-relative" id="alarmButton" data-bs-toggle="dropdown" aria-expanded="false" @click="readAlarm">
                                <i class="bi bi-bell" style="color:#333; font-size: 1.1rem;"></i>
                                <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" v-if="alarmCount > 0">
                                    {{alarmCount}}
                                    <span class="visually-hidden">unread messages</span>
                                </span>
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="alarmButton" >
                                <li v-for="alarm in alarmList"><a class="dropdown-item" :class="alarm.idx > last_read_idx ? 'fc-black' : 'fc-gray' " href="#" @click="alarmClicked(alarm)">{{ alarm.title }}</a></li>
                                <li v-if="alarmList.length == 0" class="dropdown-item">알림이 없습니다.</li>

                            </ul>
                        </li>
                    </ul>
                    
                </div>

                <a class="navbar__toogleBtn" @click="more_clicked = !more_clicked">
                    <i class="bi bi-list"></i>    
                </a>
            </nav>  
        </header>
    </div>
</template>

<script>
import 'bootstrap/dist/js/bootstrap.esm.min.js'

export default {
    name: 'Header',
    data(){
        return {
            shelter : {},

            links: [
                { title: '홈',    to: '/'        },
                // { title: '신고관리', to: '/report' },
                { title: '동물관리', to: '/animal'   },
                // { title: '진료관리', to: '/treatment' },
                // { title: '봉사관리', to: '/volunteer' },
                { title: '입양관리', to: '/adoption' },
                { title: '소식관리', to: '/news'     },
            ],
            alarmOpen : false,
            alarmList : [],
            alarmCount : 0,
            last_read_idx : 0,
            more_clicked : false,
        }
    },
    methods: {
        handleNavClick() {
            this.more_clicked = false;
        },
        deactivateMenu(){},

        isMenuActive(menu) {
            if (menu.to === '/') return this.$route.path === '/';
            return this.$route.path.startsWith(menu.to);
        },

        getAlarmList(){
            let me = this;

            me.$root.loadingStart();
            
            this.axios.get(`/alarm?email=${this.shelter.shelter_device_number}&offset=0&limit=20`)
            .then(function (res) {
                // 실제 API를 요청한다/
                // console.log(res.data);
                // me.animalList = res.data; 
                // me.animalList.push(res.data);

                me.$root.loadingStop();

                if(res.status === 200){
                    // console.log(res.data);
                    me.alarmList = res.data;

                    const lastRead = me.$cookies.get('lastReadAlarm');

                    if (lastRead) {
                        me.last_read_idx = lastRead;
                        me.alarmCount = me.alarmList.filter(alarm => alarm.idx > lastRead).length;
                    } else {
                        me.alarmCount = me.alarmList.length;
                    }

                }else{
                    alert("오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
                }


            })
        },

        readAlarm(){
            this.$cookies.set('lastReadAlarm', this.alarmList[0].idx);
        },

        alarmClicked(alarm){
            switch(alarm.alarm_type){
                case 'animal' :
                    break;
                case 'story' :
                    break;
                case 'adopt_request' : {
                    const link = this.links.find(l => l.to === '/adoption');
                    if (link) { this.handleNavClick(); this.$router.push(link.to); }
                    break;
                }
            }
        }

    },
    mounted(){
        this.shelter = this.$root.shelter;
        this.getAlarmList();
    }

}
</script>

<style scoped>
    @import '@/assets/css/header/style.css';

    a{text-decoration:none; color:#333;}

    @media (max-width: 768px) {
        .container{
            padding-left: 0 !important;
            padding-right: 0 !important;
        }
    }
</style>